import axios, { AxiosResponse } from "axios";

const BASE_API_GATEWAY_URL = APP_URLS?.base_api_gateway_url

const WEB_SERVICE_ENDPOINT = "web-service/apig/sessions";

const COMMON_HEADERS = {
  "X-CSRF-Token": document.querySelector('meta[name=csrf-token]')?.getAttribute("content"),
  "X-Requested-With": "XMLHttpRequest",
};


const ShowSpinner = (flag: boolean) => {
  const spinner = document.getElementById('spinner') || document.getElementById('ajax-spinner-id');
  if (spinner) {
    spinner.style.display = flag ? 'block' : 'none';
  }
}

const validatePtlSetup = async (email: string, student_id: string) => {
  ShowSpinner(true);
  let res: AxiosResponse<any, any> = null;
  try {
    res = await axios.post(`/ptl-setup/validations`, `user[email]=${encodeURIComponent(email)}&user[student_id]=${encodeURIComponent(student_id)}`, {
      headers: {
        ...COMMON_HEADERS,
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
    });
    ShowSpinner(false);
  } catch (e) {
    console.error(e);
    ShowSpinner(false);
    throw e;
  }
  return res;
}

const createUser = async ({ parentEmail, student_id, referral_type, referrer_code, tr_sub_source, trd_id, new_ptl_flow, email_preference, tnc_privacy }: any) => {
  ShowSpinner(true);
  let res: any = {};
  try {
    res = await axios.post(`/users`, JSON.stringify({ "user": { "email": parentEmail, "dob_year": 2000, "type": "parent", "email_preference": email_preference, "tnc_privacy": tnc_privacy, "student_id": student_id, "time_zone": null }, "form_source": "email", "via_teacher_referral": "true", "referral_type": referral_type, "referrer_code": referrer_code, "tr_sub_source": tr_sub_source, "parent_consent": true, new_ptl_flow, trd_id }), {
      headers: {
        ...COMMON_HEADERS,
        'Content-Type': 'application/json'
      },
    });
    ShowSpinner(false);
  } catch (e) {
    console.error(e);
    ShowSpinner(false);
    throw e;
  }
  return res;
}

const replaceChild = async ({ new_student_id, replace_student_id, referral_type, referrer_code, tr_sub_source, trd_id }: any) => {
  ShowSpinner(true);
  let res: any = {};
  try {
    res = await axios.post(`/ptl-setup/replace-student`, JSON.stringify({new_student_id, replace_student_id, referral_type, referrer_code, tr_sub_source, trd_id}), {
      headers: {
        ...COMMON_HEADERS,
        'Content-Type': 'application/json'
      },
    });
    ShowSpinner(false);
  } catch (e) {
    console.error(e);
    ShowSpinner(false);
    throw e;
  }
  return res;
}

const linkStudent = async ({ student_id, referral_type, referrer_code, tr_sub_source, trd_id }: any) => {
  ShowSpinner(true);
  let res: any = {};
  try {
    res = await axios.post(`/ptl-setup/link-student`, JSON.stringify({user: {student_id}, referral_type, referrer_code, tr_sub_source, flow: "ptl-link-flow", trd_id}), {
      headers: {
        ...COMMON_HEADERS,
        'Content-Type': 'application/json'
      },
    });
    ShowSpinner(false);
  } catch (e) {
    console.error(e);
    ShowSpinner(false);
    throw e;
  }
  return res;
}


const forgetPassword = async ({ parentEmail, referral_type, referrer_code, trd_id }: any) => {
  ShowSpinner(true);
  let res: any = {};
  try {
    res = await axios.post(`/users/password`, JSON.stringify({user: {login: parentEmail}, referral_type, referrer_code, ptl_flow: true, trd_id}), {
      headers: {
        ...COMMON_HEADERS,
        'Content-Type': 'application/json'
      },
    });
    ShowSpinner(false);
  } catch (e) {
    console.error(e);
    ShowSpinner(false);
    throw e;
  }
  return res;
}

const changePassword = async ({ password, password_confirmation, reset_password_token, referral_type, referrer_code, trd_id }: any) => {
  ShowSpinner(true);
  let res: any = {};
  try {
    res = await axios.put(`/users/password`, JSON.stringify({user: {password, password_confirmation, reset_password_token}, referral_type, referrer_code, ptl_flow: true, trd_id, commit: "Change my password"}), {
      headers: {
        ...COMMON_HEADERS,
        'Content-Type': 'application/json'
      },
    });
    ShowSpinner(false);
  } catch (e) {
    console.error(e);
    ShowSpinner(false);
    throw e;
  }
  return res;
}


export const APIS = {
  validatePtlSetup,
  createUser,
  replaceChild,
  linkStudent,
  forgetPassword,
  changePassword
};
